import { render } from "./CreateAccount.vue?vue&type=template&id=0cf84e97&scoped=true&lang=pug"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"

import "./CreateAccount.vue?vue&type=style&index=0&id=0cf84e97&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0cf84e97"

export default script